import React, { useEffect, useState } from "react"; import { Button, Row, Col, Container, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Field, FormikProvider, useFormik } from "formik"; import { CiFloppyDisk } from "react-icons/ci"; import { store } from '../../App'; import Menubar from "../Menubar"; import autoTable from "jspdf-autotable"; import KpiService from "../../Services/KpiService"; import { IoIosReturnLeft } from "react-icons/io";import {Button as Strapbtn} from "reactstrap"; import useAlert from "../Alert/useAlert";import { Alert } from "@mui/material"; import { FaExclamationTriangle } from "react-icons/fa"; import AlertModal from "../Alert/AlertModal";


function DeptIndicatorMapping() {
   const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [data, setData] = useState([]); const [data1, setData1] = useState([]); const [searchText, setSearchText] = useState(""); const [searchText1, setSearchText1] = useState(""); const [start, setStart] = useState(0); const [maincontainer, setMaincontainer] = useState(false);const [container, setContainer] = useState(false);
  let deptid = localStorage.getItem("deptid"); let roleid = localStorage.getItem("role");
  const BackFunct=()=>{ setMaincontainer(true); setContainer(false) }
  let username = localStorage.getItem("username"); let district = localStorage.getItem("districtid"); let districtName = localStorage.getItem("districtname"); let deptName = localStorage.getItem("deptName"); 
  // let mandal = localStorage.getItem("mandalid"); 
  const formik = useFormik({
    initialValues: { indicator_id: "", checkall: "", checkdata: [], checkdata1: [] },

  })
  const getDatadistndmandal = async () => {
    let payload = { userId: username, deptId:deptid, buttonType: roleid === "60" ? "HOD" : "District" };
  
    if (roleid !== "60") { payload.districtId = district; }
    try {
      const res = await KpiService.getDistMandalmappedList(payload);
      if (res?.data?.dataList) {
        setData(res.data.dataList);
      }
    } catch (error) {
      console.error("Error fetching mapped list:", error);
    }
  };

  useEffect(() => {
     let params = { type: "get", userId: username, deptId: deptid, buttonType: roleid==="60"?"District":"CPO", districtId: "0", mandalId: "0", status_id: "1", head_id: "0000", year: "2025-26", remarks: "", role_id: "0", periodicity_id: "0000", indicaterEntryDto: [] };
        KpiService.SaveTargetEntrylist(params).then((res) => {
          if (res.data.SCODE === "02") { setMaincontainer(false); setContainer(true); } else { setContainer(false); setMaincontainer(true); }
        })
        getDatadistndmandal()
    fetchIndicatorMapping();
  }, []);


  const filteredData = searchText1.length > 0 ? data?.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText1.toLowerCase()) ); }) ); }) : data;

  const filteredData1 = searchText.length > 0 ? data1?.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()) ); }) ); }) : data1;

  const fetchIndicatorMapping = async () => {
    const params = { userId: username, deptId:deptid, type :"get", buttonType:roleid==="60"?"HOD":"District" };
    if (roleid !== "60") { params.districtId = district; }
    const res = await KpiService.deptDistMapping(params);
    setData1(res.data?.SCODE === "01" ? res.data.dataList: []);
  };


  const saveData = async () => {
    const activeSubIndicators = formik.values.checkdata.filter(item => item?.is_active).map(item => ({ ...item, }));
    if (activeSubIndicators.length === 0) {
      showAlertMessage(
        `Please select at least one ${roleid === "60" ? "District" : "Mandal"} to map`,
        "warning"
      );
      
      return;
    }
    const params = buildSaveParams(activeSubIndicators);
    store.dispatch({ type: "SHOW_SPINNER" });
    const res = await KpiService.deptDistMapping(params);
    store.dispatch({ type: "HIDE_SPINNER" });
    handleSaveResponse(res, activeSubIndicators);
  };

  const buildSaveParams = (activeSubIndicators) => ({ userId: username, deptId:deptid, type:"save", deptDistMappedList: activeSubIndicators });

  const handleSaveResponse = async (res, activeSubIndicators) => {
    if (res.data && res.data.SCODE === "01") {
      showAlertMessage(res.data.SDESC, "success"); formik.setFieldValue("checkdata", []); await fetchIndicatorMapping(); await getDatadistndmandal();
    } else if (res.data && res.data.SCODE === "02") {
      showAlertMessage(res.data.SDESC, "warning");
    }
    resetCheckdata(activeSubIndicators);
    store.dispatch({ type: "HIDE_SPINNER" });
  };
const resetCheckdata = (activeSubIndicators) => { const updatedValues = formik.values.checkdata.map(item => ({ ...item, is_active: false })); formik.setFieldValue("checkdata", updatedValues); const updatedValues1 = formik.values.checkdata1.map(item => ({ ...item, is_active1: false })); formik.setFieldValue("checkdata1", updatedValues1); };
  const handleCheckboxChange = (e, index) => { const { checked } = e.target; formik.setFieldValue(`checkdata1[${index}].is_active1`, checked); };

  const handleDelete = async (detail) => {
    const params = buildDeleteParams(detail);
    const res = await KpiService.deptDistMapping(params);
    if (res.data && res.data.SCODE === "01") { showAlertMessage("Deleted Successfully", "success"); setData1(res.data?.dataList); formik.setFieldValue("checkdata", []); await fetchIndicatorMapping(); await getDatadistndmandal(); } else if (res.data && res.data.SCODE === "02") { showAlertMessage(res.data?.SDESC, "warning"); }
    resetCheckdata();
  };

  const buildDeleteParams = (detail) => ({ userId: username, deptId:deptid, type:"delete", districtId:detail.district_id, mandalId:roleid==="60"?0:detail.mandal_code });


  const handleCheckboxChange1 = (e, index) => {
    const isChecked = e.target.checked;
    let updatedCheckdata = [...formik.values.checkdata];
    if (!filteredData[index]) {
      console.error('Filtered data index out of bounds');
      return;
    }
    if(roleid==="60"){ updatedCheckdata[index] = { is_active: isChecked, districtId: filteredData[index].district_id, mandalId: "0", };}
    if(roleid==="32"){ updatedCheckdata[index] = { is_active: isChecked, mandalId: filteredData[index].mandal_code, districtId: district, };}
    updateStartCount(updatedCheckdata);
    formik.setFieldValue('checkdata', updatedCheckdata);
  };

  const updateStartCount = (updatedCheckdata) => {
    const activeCheckboxes = updatedCheckdata.filter(item => item && item.is_active);
    const newStart = activeCheckboxes.length > 0 ? Math.max(...activeCheckboxes.map(item => item.indicator_starts)) + 1 : 1;
    setStart(newStart);
    formik.setFieldValue('checkAll', updatedCheckdata.every(item => item && item.is_active));
  };



  return (
    <>
      <Menubar />
      {maincontainer&&
        <>
      <Container fluid style={{width:"97%"}} className='map-header'>
        <div className='sa-title'> {roleid==="60"?<h2>District <span>Department Mapping</span></h2>:  <h2>Mandal <span>Department Mapping</span></h2> }</div>
      </Container>
      <Container fluid style={{width:"97%"}} className='mt-3'>
        <div className='mandal-container p-4'>
          <Row> <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select"> <label className="mb-1 fw-bold">Department Name</label> <input className="mb-3 form-control" type="text" name="dept_name" value={deptName} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} /> </Col> {roleid==="32"&& <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select"> <label className="mb-1 fw-bold">District </label> <input className="mb-3 form-control" type="text" name="dist_name" value={districtName} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }} /> </Col>} </Row>
        </div>
      </Container>
      <Container fluid style={{width:"97%"}} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6}>
                <div className='indicators'>
                  <h5>{roleid==="32"?'Select Mandals':'Select Districts'}</h5>
                  <Form inline className='search-bar'> <Row> <Col> <input type="text" className="form-control border-0" placeholder="Search" onChange={(event) => setSearchText1(event.target.value)} /> </Col> </Row> </Form>


                  <div className='indicators-info'>
                    {filteredData?.map((detail, i) => (
                      <>
                        <div key={i} className="activity-box d-flex mt-2">
                          <Form>
                            <Field type="checkbox" name={`checkdata[${i}].is_active`} className="me-4 check-box-width" id="custom-checkbox" checked={formik.values.checkdata[i]?.is_active || false} onChange={(e) => handleCheckboxChange1(e, i)} style={{ transform: 'scale(1.4)' }} />
                          </Form>
                          <div className="number-box-main d-flex align-items-center"> <div className="number-box"><p>{i + 1}</p></div> <div className="number-text"> {roleid==="60"?  <p>  {detail.district_name}</p> : <p>  {detail.mandal_name}</p>} </div> </div>
                         
                        </div>
                      </>))
                    }


                  </div>
                </div>
                <Container fluid className='d-flex justify-content-end mt-2 mb-5 btn-map'>
                  <div className=''> <Button className='map-btn ' onClick={saveData}>{roleid==="32"?"Map Mandal":'Map District'} <CiFloppyDisk className='ms-3' /></Button>{' '} </div>
                </Container>

              </Col>


              <Col xs={12} sm={12} lg={12} md={12} xl={6} xxl={6} className="agr-secto">
  <div className='indicators1'>
    <h5>{roleid === "32" ? "Mapped Mandals" : "Mapped Districts"}</h5>

    <Form inline className='search-bar'> <Row> <Col> <input type="text" className="form-control border-0" placeholder="Search" onChange={(event) => setSearchText(event.target.value)} /> </Col> </Row> </Form>

    <div className='indicators-info' id="my-table">
      {(() => {
        let serialNumber = 0;
        return filteredData1?.map((detail, i) => {

          if (!detail.indicator_name) {
            serialNumber++;
          }

          return (
            <React.Fragment key={i}>
              {detail.indicator_name ? (
                <div className='agriculture-head'>
                  <h5>{detail.indicator_name}</h5>
                </div>
              ) : (
                <div className="activity-box d-flex mt-2 justify-content-between align-items-center">
                  <div className="number-box-main d-flex align-items-center"> <div className="number-box"> <p>{serialNumber}</p> </div> <div className="number-text"> {roleid === "60" ? ( <p>{detail.district_name}</p> ) : ( <p>{detail.mandal_name}</p> )} </div> </div>

                  <div className="d-flex align-items-center">
                    <Form className="me-2"> <Field type="checkbox" id={`custom-checkbox-${i}`} name={`checkdata1[${i}].is_active1`} checked={formik.values.checkdata1[i]?.is_active1 || false} onChange={(e) => handleCheckboxChange(e, i)} className="check-box-width" /> </Form>

                    {formik.values.checkdata1[i]?.is_active1 === true && ( <Button variant="" size="sm" onClick={() => handleDelete(detail)}> <img src="../images/bin.webp" className="img-fluid bin-img" alt="delete" /> </Button> )}
                  </div>
                </div>
              )}
            </React.Fragment>
          );
        });
      })()}
    </div>
  </div>
</Col>

            </Row>
          </Form>
        </FormikProvider>
        <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} /> 
        
      </Container></>}

      {container && ( <>
          <Container style={{ width: "75%" }} className="map-header "> <div className="sa-title"> <h2> Mandal  <span>Department Mapping</span> </h2> </div> </Container>
         {roleid ==="8"&& (<div style={{marginLeft:"1150px"}}>  <Strapbtn  size="sm" variant=""className="btn mx-2 mt-1 next-btn" onClick={() => { BackFunct() }}> 
          <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </Strapbtn></div>)} <Container style={{ width: "75%", minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "flex-start", paddingTop: "100px", }} className="outer-page-content-container" >
            <Row className="w-100 justify-content-center"> <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={12}> <Alert severity="warning" icon={<FaExclamationTriangle className="blinking-icon" />} sx={{ fontSize: "16px", padding: "40px 32px", borderRadius: "8px", backgroundColor: "#fff3cd", color: "#856404", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", }} > No mapping is  required due to the unavailability of Mandal and District indicators. </Alert> </Col> </Row> </Container> </> )} </>
            
          ); }
 
export default DeptIndicatorMapping;
